import React from "react";

export const MobileIcon = (): JSX.Element => {
    return (
        <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.75 0.75H3.75C2.09315 0.75 0.75 2.09315 0.75 3.75V17.75C0.75 19.4069 2.09315 20.75 3.75 20.75H11.75C13.4069 20.75 14.75 19.4069 14.75 17.75V3.75C14.75 2.09315 13.4069 0.75 11.75 0.75Z"
                stroke="#463498"
                strokeWidth="1.5"
            />
            <path
                d="M7.75 17.2998C7.99844 17.2999 8.2002 17.5015 8.2002 17.75C8.20009 17.9984 7.99838 18.2001 7.75 18.2002C7.50153 18.2002 7.29991 17.9984 7.2998 17.75C7.2998 17.5015 7.50147 17.2998 7.75 17.2998Z"
                fill="#333333"
                stroke="#463498"
                strokeWidth="1.5"
            />
            <path d="M3.75 3.75H11.75" stroke="#463498" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};
